// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.ExemptionEducational = {
  exempReference: [],
  exemptReferenceFetched: false,
  exemptReferenceFrontloadRequest: false,
  allEducationalReference: [],
};
